<template>
  <div>
    {{ getProperDataForVehicleTimetableDeviation() }}
  </div>
</template>

<script>
import realtimeLogic from '@/services/realtimeLogic'
import erm from '@/components/UIComponents/EventDataRenderers/EventRenderersMethods.js'

export default {
  name: 'VehicleTimetableDeviationRenderer',
  props: {
    eventType: {
      type: String,
      required: true,
    },
    eventData: {
      type: String,
      required: true,
    }
  },
  methods: {
    getProperDataForVehicleTimetableDeviation() {
        const deviation = erm.getValueOutOfGivenKey('deviation', this.eventData);
        const prettyDeviation = realtimeLogic.getDeviationInRightFormat2(deviation, false);
        let resultString = erm.getTranslationForEventDescription(this.eventType);
        if (!prettyDeviation || !resultString) {
            return this.eventData;
        }
        resultString += prettyDeviation;
        return resultString;
    },
  }
};
</script>